import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

function ChatbotAdmin() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleVectorize = async () => {
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const functions = getFunctions();
      const vectorizeKnowledgeBase = httpsCallable(functions, 'vectorizeKnowledgeBase');
      const response = await vectorizeKnowledgeBase();
      setResult(response.data);
    } catch (err) {
      console.error("Error calling vectorizeKnowledgeBase:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px' }}>
      <h2>Chatbot Admin Panel</h2>
      <p>
        This panel allows you to manage the chatbot's knowledge base.
      </p>
      <button onClick={handleVectorize} disabled={loading}>
        {loading ? 'Vectorizing...' : 'Vectorize Knowledge Base'}
      </button>
      {result && (
        <div style={{ marginTop: '20px', color: 'green' }}>
          <h4>Success!</h4>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
      {error && (
        <div style={{ marginTop: '20px', color: 'red' }}>
          <h4>Error</h4>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
}

export default ChatbotAdmin;
